"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventResolutionUpdate = exports.EventResolutionCreate = exports.EventResolutionQuery = exports.EventResolutionTransport = exports.EventResolution = exports.EventResolutionTypeLabels = exports.EventResolutionType = exports.EventResolutionTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const OneOffPickupRequest_1 = require("../route-planning/OneOffPickupRequest");
const CommercialLineItem_1 = require("../subscriptions-and-billing/CommercialLineItem");
// import { RouteEventEmbeddedIntoResolution } from './RouteEvent';
exports.EventResolutionTypes = [
    /**
     * Creates an internal ticket and assigns it to the billing team
     */
    'ADD_CHARGE',
    /**
     * Also creates an internal ticket and assigns it to the billing team, but for a discount
     */
    'ADD_DISCOUNT',
    /**
     * The event self-resolving and no further action is needed, or the event was resolved through manual intervention and requires no automated actions.
     */
    'DO_NOTHING',
    /**
     * Creates one extra pickup stop and turns the DOUBLE_PICKUP column field to true
     */
    'DOUBLE_PICKUP',
    /**
     * Creates one extra pickup stop
     */
    'EXTRA_PICKUP',
    /**
     * Creates an extra pickup and adds it to a temporary route, creates a temporary route if one does not exist
     */
    'ADD_TO_TEMP_ROUTE',
];
exports.EventResolutionType = typebox_1.Type.Union(exports.EventResolutionTypes.map((val) => typebox_1.Type.Literal(val)));
exports.EventResolutionTypeLabels = {
    ADD_CHARGE: {
        singular: 'Add Charge',
    },
    ADD_DISCOUNT: {
        singular: 'Add Discount',
    },
    DO_NOTHING: {
        singular: 'Do Nothing',
    },
    DOUBLE_PICKUP: {
        singular: 'Double Pickup',
    },
    EXTRA_PICKUP: {
        singular: 'Extra Pickup',
    },
    ADD_TO_TEMP_ROUTE: {
        singular: 'Add to Temporary Route',
    },
};
exports.EventResolution = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // event: RouteEvent,
    eventID: typebox_1.Type.String({ format: 'uuid' }),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    resolvedAt: typebox_1.Type.String({ format: 'date-time' }),
    type: exports.EventResolutionType,
    lineItem: typebox_1.Type.Optional(CommercialLineItem_1.CommercialLineItemTransport),
    metadata: common_1.MetaData,
});
exports.EventResolutionTransport = exports.EventResolution;
// export const EventResolutionPrimaryTransport = Type.Intersect([
//   Type.Omit(EventResolution, ['eventID']),
//   Type.Object({
//     event: RouteEventEmbeddedIntoResolution,
//   }),
// ]);
exports.EventResolutionQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        eventID: typebox_1.Type.String({ format: 'uuid' }),
        resolvedBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
        resolvedAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    }),
]));
exports.EventResolutionCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.EventResolution, ['id', 'haulerID', 'customerID', 'resolvedAt', 'lineItem', 'metadata']),
    typebox_1.Type.Object({
        resolvedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })), // Optional because it will default to now if not provided
        forceIfActionNotRequired: typebox_1.Type.Optional(typebox_1.Type.Boolean({
            description: 'If true, will allow creating an EventResolution for an event that does not require action',
        })),
        createOneOffPickupRequest: typebox_1.Type.Optional(OneOffPickupRequest_1.OneOffPickupRequestResolutionEmbeddedCreate),
        createLineItem: typebox_1.Type.Optional(CommercialLineItem_1.CommercialLineItemCreate),
        attachLineItemID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
exports.EventResolutionUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.EventResolution, ['id', 'haulerID', 'customerID', 'type', 'metadata']),
    typebox_1.Type.Object({ notes: (0, common_1.Nullable)(typebox_1.Type.String()) }),
]));
//# sourceMappingURL=EventResolution.js.map